module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 34
// module chunks = 0